import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ShopService } from '@app/services/shops/shop.service';
import { ProductListItem } from '@storybook/components/product-list/product-list.component';
import { OrderProtectionFormGroup, OrderProtectionProductView } from '../../model';

@Component({
  selector: 'order-protection-settings',
  templateUrl: './order-protection-settings.component.html',
  styleUrls: ['./order-protection-settings.component.scss'],
  standalone: false,
})
export class OrderProtectionSettingsComponent {
  @Input() formGroup: FormGroup<OrderProtectionFormGroup>;
  @Input() partnerApplicationId = '';
  @Input() set productView(view: OrderProtectionProductView) {
    this._productView = view;
    this.products =
      view?.state === 'found'
        ? [
            {
              id: view.productId ?? '',
              name: view.title ?? '',
              imageUrl: view.imageUrl ?? undefined,
              price: view.meta ?? undefined,
            },
          ]
        : [];
  }

  get productView(): OrderProtectionProductView {
    return this._productView;
  }

  products: ProductListItem[] = [];

  private _productView: OrderProtectionProductView;

  constructor(
    private router: Router,
    private shopService: ShopService,
  ) {}

  navigateToIntegrations(): void {
    this.router.navigate(['/settings/integrations']);
  }

  onExternalLink(product: ProductListItem): void {
    const productId =
      typeof product.id === 'string' && product.id.includes('/') ? product.id.split('/').pop() : product.id;
    const trimmedShopName = this.shopService.shopSignal().name.split('.myshopify.com')[0];
    window.open(`https://admin.shopify.com/store/${trimmedShopName}/products/${productId}`, '_blank');
  }
}
